import { CarrierOverviewPage } from 'shared/modules/carrier-profile/overview/CarrierOverviewPage';
import { CarrierWebviewHeader } from '../../CarrierWebviewHeader';

export function CarrierOverviewScreenPage() {
  return (
    <CarrierWebviewHeader>
      <CarrierOverviewPage />
    </CarrierWebviewHeader>
  );
}
